import { CloseButton, CloseButtonProps } from '@chakra-ui/react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Icon, IconProps } from '../../Icon/Icon';

export interface CloseProps extends CloseButtonProps {
  iconProps?: Partial<IconProps>;
}

const Close = ({ iconProps, ...rest }: CloseProps): React.ReactElement | null => (
  <CloseButton {...rest}>
    <Icon icon={faTimes} {...iconProps} />
  </CloseButton>
);

export default Close;
